import { jsx } from "react/jsx-runtime";
import { DecoratorNode } from "lexical";
import { MentionComponent } from "../../plugins/index.js";
import { $convertElement, $createMentionNode } from "./MentionNode.helpers.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function MentionNode_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else MentionNode_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
class MentionNode extends DecoratorNode {
    createDOM(_config, editor) {
        const span = document.createElement('span');
        span.setAttribute('contenteditable', String(editor._editable));
        return span;
    }
    static clone(node) {
        return new MentionNode(node.__removeHandler, node.__mentionId, node.__mentionName, node.__mentionLogo, node.__mentionType, node.__key);
    }
    getMentionId() {
        return this.__mentionId;
    }
    static getType() {
        return 'mention-node';
    }
    static importDOM() {
        return {
            div: ()=>({
                    conversion: $convertElement,
                    priority: 0
                })
        };
    }
    decorate(editor) {
        return /*#__PURE__*/ jsx(MentionComponent, {
            updateNode: this.updateNode,
            initialValues: {
                name: this.__mentionName,
                id: this.__mentionId,
                logo: this.__mentionLogo,
                type: this.__mentionType
            },
            disableLink: !editor._editable,
            removeHandler: this.__removeHandler
        });
    }
    getMentionData() {
        return {
            type: this.__mentionType,
            id: this.__mentionId
        };
    }
    updateDOM() {
        return false;
    }
    insertNewAfter() {
        const newElement = $createMentionNode(this.__mentionId || '', this.__mentionName || '', this.__mentionLogo, this.__mentionType);
        return newElement;
    }
    static importJSON(serializedNode) {
        return $createMentionNode(serializedNode.mentionId, serializedNode.mentionName, serializedNode.mentionLogo, serializedNode.mentionType);
    }
    exportJSON() {
        return _object_spread_props(_object_spread({}, super.exportJSON()), {
            type: this.getType(),
            mentionId: this.__mentionId,
            mentionName: this.__mentionName,
            mentionLogo: this.__mentionLogo,
            mentionType: this.__mentionType,
            version: 1
        });
    }
    constructor(removeHandler, mentionId, mentionName, mentionLogo, mentionType, key){
        super(key), this.updateNode = ({ name, id, logo, type })=>{
            const self = this.getWritable();
            self.__mentionId = id;
            self.__mentionName = name;
            self.__mentionLogo = logo;
            self.__mentionType = type;
        };
        this.__removeHandler = removeHandler;
        this.__mentionId = mentionId || '';
        this.__mentionName = mentionName || '';
        this.__mentionLogo = mentionLogo;
        this.__mentionType = mentionType || '';
    }
}
export { MentionNode };
